import Usuario from "model/administracao/cadastro/Usuario";
import { BaseEditModel } from "model/BaseEditModel";
import NivelAprovacao from "./NivelAprovacao";

export default class NivelAprovacaoUsuario implements BaseEditModel {
    id: number;
    key: string | null = "";
    sequencial: number | null = 0;
    nivelAprovacao: NivelAprovacao;
    usuario: Usuario;

    constructor(
        id: number = 0,
        nivelAprovacao: NivelAprovacao = new NivelAprovacao(),
        usuario: Usuario = new Usuario(),

    ) {
        this.id = id;
        this.nivelAprovacao = nivelAprovacao;
        this.usuario = usuario;
    }
}
